import { createContext, type PropsWithChildren } from "react";
import useAction from "./useAction";

export const ActionContext = createContext({} as ReturnType<typeof useAction>);

const ActionProvider = ({ children }: PropsWithChildren) => (
    <ActionContext.Provider
        value={useAction()}
    >
        {children}
    </ActionContext.Provider>
);

export default ActionProvider;
